export class Confirm {
	text:any = "";
	title:any = null;
	cancelText:any="cancel";
	yesText:any = "yes";
	noText:any = "no";
	onDismiss:any;
	className:any = null;
}

export enum ConfirmResult {
	CANCEL = -1,
	NO = 0,
	YES = 1,
}
